var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ribbon"),
      _vm._v(" "),
      _c("jhi-navbar"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wrapper",
          class: { toggled: !_vm.authenticated },
          attrs: { id: "app" },
        },
        [
          _c("div", { attrs: { id: "sidebar-wrapper" } }, [_c("sidebar")], 1),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "page-content-wrapper" } },
            [
              _c("header", { class: _vm.headerClasses }, [_c("dataUser")], 1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "plr-50 container-fluid" },
                [_c("router-view")],
                1
              ),
              _vm._v(" "),
              _c("jhi-footer"),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }